import { createFileRoute } from '@tanstack/react-router'
import { OnboardingPage } from '@/features/onboarding/onboarding'

export const Route = createFileRoute('/_layout/onboarding')({
  component: OnboardingRoute,
  staticData: { title: '' },
})

function OnboardingRoute() {
  return <OnboardingPage />
}
